import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import type { ReactNode } from "react";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Wraps every "&" in a string with a body-font span so it renders as a
 * normal, classic ampersand instead of the decorative Playfair Display glyph.
 */
export function classicAmpersand(text: string): ReactNode {
  const parts = text.split("&");
  if (parts.length === 1) return text;
  return parts.map((part, i) => (
    <span key={i}>
      {part}
      {i < parts.length - 1 && <span className="classic-amp">&</span>}
    </span>
  ));
}
